/**
 * Data Loader Module
 * Handles fetching JSON data and coordinating rendering
 */

import stolpersteine from '../../data/stolpersteine.json';
import medienprojekte from '../../data/medienprojekte.json';
import filmproduktionen from '../../data/filmproduktionen.json';
import begleitmaterial from '../../data/begleitmaterial.json';
import interviews from '../../data/interviews.json';
import zitate from '../../data/zitate.json';
import site from '../../data/site.json';

import { renderStolpersteinList } from './renderers/stolperstein-list';
import { renderMapMarkers } from './renderers/map-markers';
import { renderMedienprojekte } from './renderers/medienprojekte';
import { renderFilmproduktionen } from './renderers/filmproduktionen';
import { renderBegleitmaterial } from './renderers/begleitmaterial';
import { renderZitate } from './renderers/zitate';
import { renderSiteData } from './renderers/site-data';

window.interviews = interviews;

/**
 * Load JSON Data and Render Components
 * Only loads data on the main page where dynamic content is needed
 */
export async function loadData(): Promise<void> {
  // Check if we're on a page that needs dynamic data loading
  // Subpages (stolperstein/, medienprojekt/, filmproduktion/) have static content
  const needsDataLoading = document.getElementById('stolperstein-list') ||
                           document.getElementById('medienprojekte-grid') ||
                           document.getElementById('filmproduktionen-grid') ||
                           document.getElementById('begleitmaterial-grid');

  if (!needsDataLoading) {
    // On subpages, skip loading JSON data
    return;
  }

  // Render components
  renderStolpersteinList(stolpersteine, medienprojekte, filmproduktionen);
  renderMapMarkers(stolpersteine);
  renderMedienprojekte(medienprojekte, stolpersteine);
  renderFilmproduktionen(filmproduktionen, stolpersteine);
  renderBegleitmaterial(begleitmaterial);
  renderZitate(zitate);
  renderSiteData(site);
}
